import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { formatTeamsData } from "./ChartBuilder/teamFilterComponents";

const TeamFilterHierarchyOutlined = ({
  label,
  value,
  onChange,
  name,
  options,
  disabled,
  labelColorCondition,
  renderValue,
  getOptionLabel,
  getOptionValue,
  data,
  onTeamChange,
}) => {
  const teamsList = formatTeamsData(data);

  const handleChange = (e) => {
    // Get the selected value (single selection)
    const selectedValue = e.target.value;
    console.log("Selected Team:", selectedValue);

    // Pass the single selected value to the parent component (not as array)
    onTeamChange(selectedValue);
  };

  // Don't render the component if there's no data
  if (!teamsList || teamsList.length === 0) {
    return null;
  }

  return (
    <FormControl fullWidth disabled={disabled} variant="outlined">
      <Select
        value={value}
        onChange={handleChange}
        name={name}
        renderValue={(selected) => {
          if (!selected || selected === "") {
            return <span style={{ color: "#aaa" }}>Please select team</span>;
          }
          return renderValue ? renderValue(selected) : selected;
        }}
        displayEmpty
        variant="outlined"
        style={{ borderRadius: 8 }}
      >
        {teamsList.map((option) => (
          <MenuItem
            key={getOptionValue(option)}
            value={option.label}
            style={{ marginLeft: `${option.indent * 1}rem` }}
          >
            {getOptionLabel(option)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TeamFilterHierarchyOutlined;
